import { defineStore } from "pinia";

type LoadingStoreKeys = "set-lf" | "sign-placement";
type LoadingStoreState = Record<LoadingStoreKeys, boolean>;
const defaultState = {
  "set-lf": false,
  "sign-placement": false,
};

export const useLoadingStore = defineStore("loading", {
  state: (): LoadingStoreState => defaultState,
  actions: {
    setLoading(key: LoadingStoreKeys, value: boolean) {
      this[key] = value;
    },
  },
  getters: {
    isLoading(state: LoadingStoreState) {
      return (key: LoadingStoreKeys) => state[key];
    },
  },
});
